import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FixedButton from './Menus/FixedButton';
import Chatbot from './Menus/Chatbot';
import Home from './Pages/Home';
import About from './Pages/About';
import WashingMachineService from './Pages/washing-machine-service';
import FridgeService from './Pages/fridge-service';
import ACService from './Pages/ac-service';
import TVService from './Pages/tv-service';
import Contact from './Pages/contact';
import PrivacyPolicy from './Pages/privacy-policy';
import TermsConditions from './Pages/terms-conditions';
import Micro from './Pages/Micro';

function App() {
  return (
    <BrowserRouter>
      <FixedButton />
      <Chatbot />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/washing-machine-service" element={<WashingMachineService />} />
        <Route path="/fridge-service" element={<FridgeService />} />
        <Route path="/ac-service" element={<ACService />} />
        <Route path="/tv-service" element={<TVService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Micro" element={<Micro />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
